define('TescoMobile_Reevoo/js/model/reevoo',['jquery', 'underscore'], function ($, _) {
  'use strict';

  return function () {
    return {
      skuMap: {},
      getSkuMapping: function (sku) {
        return this.skuMap[sku] ? this.skuMap[sku] : false;
      },
      updateReevooReviews: function (simpleSku) {
        var mappedSku = this.getSkuMapping(simpleSku);
        if (mappedSku != false) {
          mappedSku = mappedSku.trim();
          var perPage = $('#reevoo-reviews-tab #customer-reviews').data('per-page');
          $('div.product-info-main .sku .value').html(mappedSku);
          $('reevoo-badge').attr('product-id', mappedSku);
          this.reevooReviewsTab(mappedSku, perPage);
          this.reevooReviewsConversationsTab(mappedSku, perPage);
        }
      },
      reevooReviewsTab: function (simpleSku, perPage) {
        if ($('#tab-label-product_view_reviews').hasClass('active')) {
          $('#customer-reviews').empty();
          var h = document.getElementById('customer-reviews');
          var r = document.createElement('reevoo-embeddable');
          r.setAttribute('type', 'product');
          r.setAttribute('product-id', simpleSku);
          r.setAttribute('per-page', perPage);
          h.append(r);
        }
      },
      reevooReviewsConversationsTab: function (simpleSku, perPage) {
        if ($('#tab-label-product_view_conversations').hasClass('active')) {
          $('#customer-conversation').empty();
          var hconv = document.getElementById('customer-conversation');
          var rconv = document.createElement('reevoo-embeddable');
          rconv.setAttribute('type', 'aao');
          rconv.setAttribute('product-id', simpleSku);
          rconv.setAttribute('per-page', perPage);
          hconv.append(rconv);
        }
      }
    };
  }();
});

